function getYouTubeId(url = "") {
  try {
    const u = new URL(url);
    if (u.hostname.includes("youtu.be")) return u.pathname.replace("/", "");
    if (u.searchParams.get("v")) return u.searchParams.get("v");

    const parts = u.pathname.split("/").filter(Boolean);
    const iEmbed = parts.indexOf("embed");
    if (iEmbed >= 0 && parts[iEmbed + 1]) return parts[iEmbed + 1];

    const iShorts = parts.indexOf("shorts");
    if (iShorts >= 0 && parts[iShorts + 1]) return parts[iShorts + 1];

    return "";
  } catch {
    return "";
  }
}

export default function YouTubeEmbed({ url, title }) {
  const id = getYouTubeId(url);
  if (!id) return null;

  const embedUrl = `https://www.youtube-nocookie.com/embed/${id}?rel=0&modestbranding=1`;

  return (
    <div className="mt-4">
      <div
        className="relative w-full overflow-hidden rounded-xl border border-gray-200 dark:border-gray-800 bg-black"
        style={{ aspectRatio: "16 / 9" }}
      >
        <iframe
          src={embedUrl}
          title={title || "Project video"}
          className="absolute inset-0 w-full h-full"
          frameBorder="0"
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
        />
      </div>
    </div>
  );
}